import { StorageUtil } from '../../shared/utils/storage';

const hasVisitedAgencyPortal = 'hasVisitedAgencyPortal';

export const getHasVisitedAgencyPortal = () =>
  StorageUtil.getItem(hasVisitedAgencyPortal);

export const setHasVisitedAgencyPortal = (value: string) =>
  StorageUtil.setItem(hasVisitedAgencyPortal, value);

export const removeHasVisitedAgencyPortal = () =>
  StorageUtil.removeItem(hasVisitedAgencyPortal);
